<template>
    <div class="waiting-list-form">
        <h6>Be notified when this space becomes available</h6>
        <p>The availability of our space changes on a daily basis. Enter your email address below and we’ll let you know when this space becomes available again</p>
        <booking-alerts v-if="errors.length" :messages="errors"/>
        <form v-if="!success" @submit.prevent="submitForm">
            <div class="form-group">
                <v-input
                    v-model="formData.name"
                    :disabled="submitting"
                    type="text"
                    classes="form-control v2-styles"
                    placeholder="Name"
                    required
                />
                <v-input
                    v-model="formData.email"
                    :disabled="submitting"
                    type="email"
                    classes="form-control v2-styles"
                    placeholder="Email address"
                    required
                />
                <div class="input-wrap">
                    <the-mask
                        v-model="formData.number"
                        :disabled="submitting"
                        type="tel"
                        class="form-control v2-styles"
                        placeholder="Phone number"
                        required
                        :mask="['P####################']"
                        :tokens="maskTokens"
                    />
                </div>
            </div>
            <button :disabled="submitting" type="submit" class="btn btn-green">
                <template v-if="submitting">
                    <i class="fa fa-spinner fa-spin"/> Submitting&hellip;
                </template>
                <template v-else>
                    Submit
                </template>
            </button>
        </form>
        <div v-else class="alert alert-success">
            <p>Your details have been submitted, we'll let you know when new spaces are added in your area.</p>
        </div>
    </div>
</template>

<script>
    import SpaceRepository from '../../repositories/SpaceRepository';
    import { normaliseErrors } from '../../modules/error-handlers';
    import BookingAlerts from '../space/booking-form/Alerts';
    import { TheMask } from 'vue-the-mask';

    export default {
        name: 'waiting-list-form-widget',

        components: {
            BookingAlerts,
            TheMask,
        },

        props: {
            spaceId: {
                type: Number,
            },
        },

        data() {
            return {
                maskTokens: {
                    'P': {pattern: /[0|+]/},
                    '#': {pattern: /\d/},
                },
                submitting: false,
                hasSubmitted: false,
                errors: [],
                formData: {
                    name: null,
                    email: null,
                    number: null,
                },
                success: false,
            };
        },

        methods: {
            submitForm() {
                this.submitting = true;

                SpaceRepository.addToWaitingList(this.spaceId, this.formData)
                    .then(() => {
                        this.submitting = false;
                        this.success = true;
                    })
                    .catch((response) => {
                        this.errors = normaliseErrors(response);
                        this.submitting = false;
                    });
            },
        },
    };
</script>

<style lang="less" scoped>
    @import (reference) "~assets/less/variables.less";
    @import (reference) "~bootstrap/less/mixins/clearfix.less";
    @import (reference) "~bootstrap/less/mixins/buttons";
    @import (reference) "~assets/less/components/mixins/buttons";

    .waiting-list-form {
        font-size: 13px;
        font-weight: 400;
        margin-bottom: 10px;
        .alert-danger {
            p {
                margin-bottom: 0;
            }
        }
        .form-group > * {
            padding: 2.5px 0;
        }
        .alert {
            font-size: 13px;
            padding: 13px;
        }
        h6 {
            font-family: @headings-font-family;
            font-size: 1.071428571em;
            font-weight: 700;
            margin: 0 0 .866666667em;
        }
        form {
            .clearfix;
        }
        button {
            float: left;
            color: #ffffff;
            font-family: @headings-font-family;
            font-size: 13px;
            font-weight: 700;
            padding: 10px 27px;
        }
    }

    .waiting-list-form {
        padding: 14px 14px 0;
        font-size: 14px;
        font-weight: 300;
        line-height: 1.625em;

        h6 {
            font-size: 18px;
            font-weight: 700;
        }
        input[type=email].form-control.form-control {
            color: #2f3035;
            font-size: 13px;
            height: auto;
            padding: 14px;
        }
        .btn-green.btn-green {
            .btn-yellow;
            width: 100%;
            color: #2f3136;
            font-size: 14px;
            font-weight: 700;
        }
    }
</style>
